export default class TutorialSection
{

/**
 *
 */
constructor(index,section)
 {
    this.Index=index;
    this.Section=section;
 }
 
 /** @type{number} */
 Index;

 /** @type{string} */
 Section;



}